import * as z from 'zod';

export const skillCategoryFormSchema = z.object({
  Title: z.string().trim().min(1, { message: 'TITLE_REQUIRED' }),
});

export type SkillCategoryFormValues = z.infer<typeof skillCategoryFormSchema>;
